import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { FacebookShareButton } from 'react-share';
import { useVerifyIsMobile } from '../../../../../hooks/useVerifyIsMobile';
import { GetRegion } from 'constants.js';
import {
  getConfigFacebook,
  selectVCardContent,
} from '../../../selectors/vcard.selector';
import getContentAvailability from '../../../../../utils/getContentAvailability';
import getContentType from '../../../../../utils/getContentType';
import { pushGTMEvent } from '../../../../Player/utils/analytics';
import deleteSymbols from '../../../../../utils/deleteSymbols';

const shareData = {
  url: location.href,
};

const ShareContentButton = () => {
  const asset = useSelector(state => state.asset);
  const translations = useSelector(state => state.translations);
  const { isMobile } = useVerifyIsMobile();
  const content = useSelector(selectVCardContent);
  const fbconfig = useSelector(
    getConfigFacebook({
      country: GetRegion(),
      url: window.location.pathname,
    }),
  );

  const shareEvent = () => {
    const contentAvailability = getContentAvailability(
      content.types,
      content.proveedorCode,
    );
    const contentType = getContentType(content);
    pushGTMEvent({
      event: 'interaction_content',
      interaction_type: 'share',
      content_section: 'vcard',
      item_id: content.group_id,
      content_name: content.title,
      content_type: contentType,
      content_category: deleteSymbols(
        content.genres
          .map(genre => genre.desc)
          .toString()
          .toLowerCase(),
      ),
      content_availability: contentAvailability.toString(),
    });
  };

  const handleMobileShareClick = async () => {
    shareEvent();
    try {
      await navigator.share(shareData);
    } catch (error) {
      return null;
    }
  };
  const handleBeforeShareClick = async () => {
    shareEvent();
  };

  return (
    <Fragment>
      {isMobile ? (
        <div className="ActionButton__content" onClick={handleMobileShareClick}>
          <div className="ActionButton__content__image">
            <img src={asset.vcard_access_option_icon_share} alt="play" />
          </div>
          <p className="ActionButton__content__text">
            {translations.vcard_access_option_button_share}
          </p>
        </div>
      ) : (
        <FacebookShareButton
          url={fbconfig.btnFacebookShare.urlToShare}
          beforeOnClick={handleBeforeShareClick}
        >
          <div className="ActionButton__content">
            <div className="ActionButton__content__image">
              <img src={asset.vcard_access_option_icon_share} alt="play" />
            </div>
            <p className="ActionButton__content__text">
              {translations.vcard_access_option_button_share}
            </p>
          </div>
        </FacebookShareButton>
      )}
    </Fragment>
  );
};

export default ShareContentButton;
